import { resolveReferenceImageDisplayUrl } from '../api/referenceUpload'
import type { ImageLightboxItem } from '../components/ImageLightbox'
import type { ComicPage } from './comicTypes'

export function comicPageToLightboxItems(page: ComicPage | null): ImageLightboxItem[] {
  if (!page) return []
  const items: ImageLightboxItem[] = []
  const seen = new Set<string>()
  const push = (src: string, subtitle: string) => {
    const key = src.trim()
    if (!key || seen.has(key)) return
    seen.add(key)
    items.push({ src: key, subtitle, alt: subtitle })
  }
  if (page.pageImageUrl?.trim()) {
    push(page.pageImageUrl, '当前整页')
  }
  page.pageCandidates.forEach((c, i) => {
    if (c.imageUrl?.trim()) push(c.imageUrl, `候选 ${i + 1}`)
  })
  return items
}

export function lightboxIndexForPageCandidate(page: ComicPage | null, candidateId: string): number {
  const items = comicPageToLightboxItems(page)
  const url = page?.pageCandidates.find((c) => c.id === candidateId)?.imageUrl?.trim()
  if (!url) return 0
  return lightboxIndexForImageUrl(items, url)
}

export function lightboxIndexForImageUrl(items: ImageLightboxItem[], imageUrl: string): number {
  const target = resolveReferenceImageDisplayUrl(imageUrl.trim())
  const idx = items.findIndex(
    (it) => resolveReferenceImageDisplayUrl(it.src.trim()) === target,
  )
  return idx >= 0 ? idx : 0
}
